import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import constants from '../constants';
import StoreLocatorMarker from './StoreLocatorMarker';

const SingleStoreMap = (props) => {
  const { storeObj } = props;

  const [activeMarkerIndex, setActiveMarkerIndex] = useState(-1);

  const [mapReference, setMapReference] = useState(null);
  const [mapsReference, setMapsReference] = useState(null);

  /* Map */
  const defaultCenter = {
    lat: storeObj.lat,
    lng: storeObj.lng,
  };

  const onMarkerClose = () => {
    setActiveMarkerIndex(-1);
  };

  const onDealerSelect = () => {
    window.scrollBy({
      behavior: 'smooth',
      top: 200
    })
  }

  const onMapChildClick = (index) => {
    if (storeObj) {
      mapReference.panTo({
        lat: storeObj.lat,
        lng: storeObj.lng,
      });
      const mapDivHeight = mapReference.getDiv().offsetHeight;
      if (mapDivHeight < 400) {
        mapReference.panBy(0, -mapDivHeight / 3);
      }
    }
    setActiveMarkerIndex(index);
  };

  const onGoogleApiLoaded = ({ map, maps }) => {
    setMapReference(map);
    setMapsReference(maps);
  };

  const createMapOptions = (maps) => {
    return {
      streetViewControl: true,
      clickableIcons: false,
      styles: [
        {
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
      ],
    };
  };

  return (
    <div className="single-store-map-component">
      <div className="map-wrapper">
        <GoogleMapReact
          bootstrapURLKeys={{
            key: constants.googleMapApiKey,
          }}
          defaultCenter={defaultCenter}
          defaultZoom={16}
          onChildClick={onMapChildClick}
          onGoogleApiLoaded={onGoogleApiLoaded}
          yesIWantToUseGoogleMapApiInternals={true}
          options={createMapOptions}
        >
          <StoreLocatorMarker
            key={storeObj.index}
            lat={storeObj.lat}
            lng={storeObj.lng}
            store={storeObj}
            show={storeObj.index == activeMarkerIndex}
            mapsReference={mapsReference}
            onClose={onMarkerClose}
            onDealerSelect={onDealerSelect}
          />
        </GoogleMapReact>
      </div>
    </div>
  );
};

export default SingleStoreMap;
